import { gql } from 'apollo-boost';
import { QUOTED_URL_META_FIELDS } from '../../fragments/message/quoted-url-meta-fields';
import { TRANSCRIPT_FIELDS } from '../../fragments/message/transcript-fields';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';

export const CREATE_MESSAGE_FROM_AUDIO = gql`
    mutation($data: CreateMessageFromAudioInput!) {
        createMessageFromAudio(data: $data) {
            __typename
            ... on Message {
                id
                clientRequestId
                parentMessageId
                referencedMessageId
                threadRootMessageId
                email { subject from receivedAt preview hasOriginalHtml }
                laneKind
                aiRole
                aiProvider
                aiModel
                title
                body
                createdAt
                deletedAt
                updatedAt
                lastViewedAt
                lastMovedAt
                image {
                    url
                    cdn_url
                    thumbnail {
                        sm
                        md
                        lg
                        xl
                        original
                        compressed {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                    }
                    name
                    displayName
                    type
                    format
                    size
                    width
                    height
                    aspect_ratio
                    duration
                    public_id
                }
                file {
                    url
                    cdn_url
                    thumbnail {
                        sm
                        md
                        lg
                        xl
                        original
                        compressed {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                    }
                    name
                    displayName
                    type
                    format
                    size
                    mime
                    width
                    height
                    aspect_ratio
                    duration
                }
                isCheckbox
                isChecked
                isStarred
                ${TRANSCRIPT_FIELDS}
                reminderAt
                eventArtifactId
                event { startDate endDate startTime endTime timeZone location rawDate needsReview }
                reminderUpdatedAt
                reminderFiredAt
                reminderCancelledAt
                reminderVersion
                reminderDeliveryType
                reminderMessage
                automaticReminderNeedsReview
                dueAt
                dueTimezone
                dueKind

                dueSeriesEndAt
                alerts {
                    id
                    offsetMinutes
                    deliveryType
                    firedAt
                }
                metadata {
                    highlight {
                        color
                        highlightId
                    }
                    savedFrom {
                        channel
                        source
                        method
                        type
                        device
                        deviceVersion
                        browser
                        browserVersion
                        appVersion
                        platform
                    }
                    updatedFrom {
                        type
                        device
                        deviceVersion
                        browser
                        browserVersion
                        appVersion
                        platform
                    }
                    chatContext {
                        isSyntheticConversation
                        sources {
                            sourceType
                            messageId
                            folderId
                            sourceFolderTitle
                            title
                            body
                            caption
                            keywords
                            ocrText
                            suggestedFolderTitle
                            sourceUrl
                            publisher
                            imageUrl
                            fileName
                            fileMime
                            createdAt
                        }
                    }
                    slashAction {
                        actionId
                        scope
                        displayCommand
                        userInput
                        resolvedPrompt
                    }
                }
                folder {
                ...FolderCacheSafeFields
            }
                urlMeta {
                    author
                    date
                    description
                article_url
                article_body
                article_pull_provider
                reddit_comments {
                    author
                    body
                    score
                    created_utc
                    permalink
                }
                sourcePlatform
                sourceMetrics {
                    score
                    upvoteRatio
                    commentCount
                    createdUtc
                    viewCount
                    likeCount
                    shareCount
                    saveCount
                    engagementRate
                }
                sourcePlatformMeta {
                    reddit {
                        subreddit
                        permalink
                        over18
                        locked
                        stickied
                        postHint
                        isGallery
                    }
                }
                    image
                    gallery_images
                    gallery {
                        type
                        image
                        image_name
                        media {
                            public_id
                            url
                            cdn_url
                            name
                            displayName
                            type
                            format
                            size
                            aspect_ratio
                            width
                            height
                            mime
                            duration
                            ocrText
                        }
                        width
                        height
                        aspect_ratio
                        media_url
                        media_name
                        media_cdn_url
                        media_hls_url
                        media_duration
                        media_has_audio
                    }
                    image_cdn_url
                    logo
                    publisher
                    title
                    url
                    public_id
                    width
                    height
                    format
                    aspect_ratio
                    size
                    author_image
                    author_image_cdn_url
                    author_image_public_id
                    author_image_size
                    author_image_format
                    author_image_aspect_ratio
                    author_image_width
                    author_image_height
                    author_image_original
                    embed {
                        html
                        script {
                            src
                            async
                            charset
                        }
                    }
                    ${QUOTED_URL_META_FIELDS}
                }
            }
            ... on CreateMessageFromAudioError {
                message
                code
            }
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;